/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';
import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import {
    WidgetSubscriberMaxCostsListItemRightStyled,
} from '../../WidgetSubscribersMaxCosts/styled/widgetSubscriberMaxCostsStyled';
import { IWidgetStyled } from '../../widgetTypes';

export const WidgetPaymentHistoryStyled = styled(WidgetBlockStyled).attrs((props: IWidgetStyled) => ({
    className: `widget__widget-payment-history
    ${props.isEmpty ? 'widget__widget-payment-history__empty' : ''}
    ${props.error ? 'widget__widget-payment-history__error' : ''}`,
}))<IWidgetStyled>`
    display: flex;
    flex-direction: column;
    &.widget__widget-payment-history__error,
     &.widget__widget-payment-history__empty {
        height: 300px;
    }
`;

export const WidgetPaymentHistorySuccessStyled = styled.div.attrs({
    className: 'widget-payment-history',
})`
    .widget-payment-history__list {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        line-height: 1.6;
        margin-bottom: 4px;
    }
`;

export const WidgetPaymentHistoryListItemPaymentTypeStyled = styled.div`
    ${fonts.textSmall};
    color: ${colors.textColorOpacity};
`;

export const WidgetPaymentHistoryListItemRightStyled =
    styled(WidgetSubscriberMaxCostsListItemRightStyled)``;
